import { create } from "apisauce";
import { API } from "./API";
import { store } from "../store/store";
import { updateAuth } from "../store/Reducers/authReducer";

const APIRequest = create({
  baseURL: API,
  // 10s was too short for forecast endpoints — slow responses showed as "(canceled)" in DevTools.
  timeout: 45000,
  timeoutErrorMessage: "Please try Again server is Busy now",
});

const hideLoaderAPIs = [
  "find-driver",
  "offers",
  "location",
  "notifications",
  "feedback",
  "privacy-policy",
  "message",
  "ride_chat",
  "toggle",
  "upload",
  "conversations"
];

APIRequest.addRequestTransform((config) => {
  const { AUTH,ADMIN_AUTH } = store.getState();
  var parts = config.url.split("/");
  var { stopLoading } = config?.params || config?.data || {};
  var lastSegment = parts.pop() || parts.pop();
  // console.log("lastsegment-----------",lastSegment)
  if (!hideLoaderAPIs.includes(lastSegment) && !stopLoading) {
    store.dispatch(updateAuth({ loading: true }));
  }
  config.headers = {
    Authorization: `Bearer ${ ADMIN_AUTH?.isAdminLoggedIn?ADMIN_AUTH?.adminToken: AUTH?.token}`,
    ...config.headers,
    'ngrok-skip-browser-warning': 'true',
  };
  return config;
});

APIRequest.addResponseTransform((response) => {
  store.dispatch(updateAuth({ loading: false }));
  return response;
});
export default APIRequest;
